import styled from 'styled-components'

import { AdornmentPosition } from '@/models/common'

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const Border = styled.span<{ $error: boolean }>`
  position: relative;
  display: block;
  width: 100%;
  box-shadow: 0 -1px 0 ${({ theme, $error }) => ($error ? theme.colors.error : theme.colors.heading)} inset;
  height: 2px;

  &:before,
  &:after {
    content: '';
    height: 1.25px;
    width: 0;
    bottom: 0;
    position: absolute;
    background: ${({ theme, $error }) => ($error ? theme.colors.error : theme.colors.violet)};
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:before {
    left: 50%;
  }

  &:after {
    right: 50%;
  }
`

export const StyledInput = styled.input<{
  $adornmentPosition?: AdornmentPosition
  $error: boolean
  $fieldValue?: string
}>`
    display: block;
    appearance: none;
    width: 100%;
    min-height: 32px;
    box-sizing: border-box;
    background-color: transparent;
    border: none;
    font-family: ${({ theme }) => theme.fonts.textCondensedFont};
    font-size: ${({ theme }) => theme.fonts.fontSize14};
    line-height: 1.25;
    color: ${({ theme }) => theme.colors.heading};
    padding: 6px 0;
    padding-right: ${({ $adornmentPosition, theme }) => $adornmentPosition === AdornmentPosition.END && theme.space.S56};
    padding-left: ${({ $adornmentPosition, theme }) => $adornmentPosition === AdornmentPosition.START && theme.space.S24};
    text-overflow: ellipsis;
    overflow: hidden;
    resize: none;

    &:disabled {
        cursor: not-allowed;
        background: ${({ theme }) => theme.colors.statusWhiteGray};
    }

    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${({ theme }) => theme.colors.greyLight};
    }

    &::-ms-clear {
        display: none;
    }

    &:focus {
        outline: none;
    }

    &:not(:disabled):hover ~ ${Border} {
        box-shadow: 0 -2px 0 ${({ theme, $error }) => ($error ? theme.colors.error : theme.colors.heading)} inset;
    }

    &:focus ~ ${Border}:before, &:focus ~ ${Border}:after {
        width: 50%;
    }
}
`
